import type { ComponentType } from 'react';

import { Targets, type TargetType } from '@atlassiansox/cross-flow-base-types';
import {
	type LogoProps,
	ConfluenceLogo,
	JiraLogo,
	JiraProductDiscoveryLogo,
	JiraServiceManagementLogo,
} from '@atlaskit/logo';
import { useOnboardingModalContext } from '../../controllers/onboarding-modal-context/index.tsx';

type CommonContent = {
	Logo: ComponentType<LogoProps>;
};

const logoForTargetProduct: { [k in TargetType]?: ComponentType } = {
	[Targets.JIRA_SERVICE_DESK]: JiraServiceManagementLogo,
	[Targets.JIRA_PRODUCT_DISCOVERY]: JiraProductDiscoveryLogo,
	[Targets.JIRA_SOFTWARE]: JiraLogo,
	[Targets.CONFLUENCE]: ConfluenceLogo,
};

export const useCommonContent = (): CommonContent => {
	const context = useOnboardingModalContext();

	if (!context) {
		throw new Error('useCommonContent must be used within a OnboardingModalProvider');
	}

	if (!context.targetProduct) {
		throw new Error('Missing target product');
	}

	return getLogoForTargetProduct(context.targetProduct);
};

export const getLogoForTargetProduct = (targetProduct: TargetType): CommonContent => {
	return {
		Logo: logoForTargetProduct[targetProduct] || JiraLogo,
	};
};
